import { render } from "./invoice_overview.html?vue&type=template&id=61af4164&external"
import script from "./invoice_overview.js?vue&type=script&lang=js&external"
export * from "./invoice_overview.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__